import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { format, startOfMonth, endOfMonth, eachDayOfInterval } from 'date-fns';
import { hu } from 'date-fns/locale';
import AddIcon from '@material-ui/icons/Add';

import { Button, FormControlLabel, IconButton, Switch } from '@material-ui/core';
import NewCarDay from './NewCarDay';
import { NewObjectButton } from '../../../common/table/NewObjectButton';
import CarDayTable from './CarDayTable';
import CarDayTableOther from './CarDayTableOther';

const getDaysInMonth = (date) => {
    const start = startOfMonth(date);
    const end = endOfMonth(date);
    const res = eachDayOfInterval({ start, end });
    const result = res.map(day => {
        return {
            date: day,
            dateString: getDateString(day),
            type: (day.getDay() === 0 || day.getDay() === 6) ? 'WEEKEND' : 'WEEKDAY'
        };
    });
    return result;
};

const getDateString = (date) => {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;
    return [year, month, day].join('-');
}


function CarDayPage(props) {
    const [carDays, setCarDays] = useState([]);
    const [mode, setMode] = useState(false);
    const [year, setYear] = useState(new Date().getFullYear());
    const [month, setMonth] = useState(new Date().getMonth());
    const [daysInMonth, setDaysInMonth] = useState(getDaysInMonth(new Date(year, month, 1)));

    const callApi = useCallback(async () => {
        //call cardays
        const response = await axios.get(`/api/cardays/${year}/${month + 1}`)
        // console.log(response.data);
        return response.data;
    }, [year, month]);

    useEffect(function () {
        setDaysInMonth(getDaysInMonth(new Date(year, month, 1)));
        callApi()
            .then(res => setCarDays(res))
            .catch(err => console.log(err));
    }, [year, month, callApi]);

    const refresh = () => {
        console.log("refresh");
        callApi()
            .then(res => setCarDays(res))
            .catch(err => console.log(err));

    }

    const now = new Date(); // Get current date
    const currentYear = now.getFullYear(); // Get current year
    const currentMonth = now.getMonth(); // Get current month (January is 0)

    const handleNextMonth = () => {
        if (currentYear === year && month === currentMonth) {
            return;
        }
        if (month < 11) {
            setMonth(month + 1);
        } else if (month === 11) {
            setMonth(0);
            setYear(year + 1);
        }
    }
    const handlePreviousMonth = () => {
        if (month > 0) {
            setMonth(month - 1);
        } else if (month === 0) {
            setMonth(11);
            setYear(year - 1);
        }
    }
    const handleNow = () => {
        setMonth(currentMonth);
        setYear(currentYear);
    }
    const handleModeChange = () => {
        setMode(!mode);
    }

    return (<>
        <div className="workday-container">
            <div className="buttons-left">
                <Button variant="contained" onClick={handleNow}>Ma</Button>
                <Button variant="contained" onClick={handlePreviousMonth}>Előző</Button>
                <Button variant="contained" onClick={handleNextMonth}>Következő</Button>
            </div>
            <div className="title">
                {`${year}. ${format(new Date(year, month), 'MMMM', { locale: hu })}`}
            </div>
            {/* <div className="mode">
                <FormControlLabel
                    control={<Switch checked={mode} onChange={handleModeChange} name="other" color="primary" />}
                    label="Másik nézet"
                />
            </div> */}
        </div>
        {/* {mode ?
            <CarDayTableOther daysInMonth={daysInMonth} data={carDays} refresh={() => refresh()} />
            : */}
        <CarDayTable daysInMonth={daysInMonth} data={carDays} refresh={() => refresh()} />

        {/* } */}

    </>);
};
export default CarDayPage;